var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',{attrs:{"id":"lectures","title":"Lectures","back":""}},[_c('lecture',{ref:"lecture",attrs:{"id":parseInt(_vm.$route.params.id)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }